import { Box, IconButton, Loader, Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { RevertSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { generalToolTips } from '../../bi/types';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
export const VerifyPageButton = _ref => {
  let {
    onClick,
    isLoading,
    failedTaskCount,
    taskCount,
    pageId
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const usesClassicModalChrome = capabilities.usesClassicModalChrome;
  const ButtonTooltip = _ref2 => {
    let {
      children,
      content,
      tooltipType
    } = _ref2;
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: content,
      enterDelay: 200,
      moveBy: {
        y: 4
      },
      size: "small",
      inline: true,
      onShow: () => {
        biLogger.pageScanTooltipView({
          failedTaskCount,
          taskCount,
          tooltipName: tooltipType
        });
      }
    }, children);
  };
  const compactPanelChrome = capabilities.compactPanelChrome;
  const verifyButton = /*#__PURE__*/React.createElement(ButtonTooltip, {
    content: t('accessibility-wizard.verify-change-button.rescan-page-button.tooltip-content'),
    tooltipType: generalToolTips.rescanPage
  }, /*#__PURE__*/React.createElement(Box, {
    marginLeft: "SP1"
  }, /*#__PURE__*/React.createElement(IconButton, {
    priority: compactPanelChrome ? 'tertiary' : 'secondary',
    size: "tiny",
    skin: compactPanelChrome ? 'dark' : 'standard',
    onClick: e => {
      e.stopPropagation();
      biLogger.pageScanClick({
        failedTaskCount,
        pageId,
        taskCount
      });
      onClick();
    },
    onKeyDown: e => {
      if (['Enter', ' '].includes(e.key)) {
        e.stopPropagation();
      }
    }
  }, /*#__PURE__*/React.createElement(RevertSmall, null))));
  const loader = /*#__PURE__*/React.createElement(ButtonTooltip, {
    content: t('accessibility-wizard.verify-change-button.rescan-page-loader.tooltip-content'),
    tooltipType: generalToolTips.verifyChanges
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    backgroundColor: compactPanelChrome ? 'none' : 'D80',
    border: compactPanelChrome ? 'none' : '1px solid',
    borderColor: compactPanelChrome ? undefined : 'D60',
    borderRadius: usesClassicModalChrome ? '50%' : '4px',
    height: "22px",
    width: "22px"
  }, /*#__PURE__*/React.createElement(Box, {
    marginTop: "2px"
  }, /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }))));
  return isLoading ? loader : verifyButton;
};
//# sourceMappingURL=verify-page-button.js.map